import FormRoot from './Root'
import FormErrorBanner from './ErrorBanner'
import FormTakerData from './TakerData'
import FormAddressContact from './AddressContact'
import FormFiscalData from './FiscalData'

export const Forms = {
  root: FormRoot,
  errorBanner: FormErrorBanner,
  takerData: FormTakerData,
  addressContact: FormAddressContact,
  fiscalData: FormFiscalData,
}
